export const USER_LIMIT = 500
export const INITIAL_PAGINATION = { count: 0, limit: 0, offset: 0 }
export const UNASSIGNED = 'Unassigned'
export const ASSIGNED = 'Assigned'

export const SEARCH_LIMIT = 3

export const ASSIGN = 'Assign'
export const UNASSIGN = 'UnAssign'

export type ASSIGN_UNASSIGN = 'Assign' | 'Unassign'
export type IUseSelectionTpe = 'Assign' | 'Unassign' | 'None'

export const getSelectedMenu = (currentUserId: string, claimOwnerId?: string) => {
  let label: IUseSelectionTpe

  if (claimOwnerId === currentUserId) {
    label = 'Assign'
  } else if (!claimOwnerId) {
    label = 'Unassign'
  } else {
    label = 'None'
  }

  return label
}

export const OUTBOUND_USER = '@outbound.ai'
